import { EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
var PasswordValidation = /** @class */ (function () {
    function PasswordValidation() {
    }
    PasswordValidation.MatchPassword = function (control) {
        var password = control.get('password').value;
        var confirmPassword = control.get('confirmPassword').value;
        if (password !== confirmPassword) {
            control.get('confirmPassword').setErrors({ matchPassword: true });
        }
        else {
            return null;
        }
    };
    return PasswordValidation;
}());
export { PasswordValidation };
var ChangePasswordFormComponent = /** @class */ (function () {
    function ChangePasswordFormComponent(formBuilder) {
        this.formBuilder = formBuilder;
        this.hidePassword = true;
        this.hideConfirmPassword = true;
        this.loading = false;
        this.changePassword = new EventEmitter();
        this.form = this.formBuilder.group({
            password: [null, [Validators.required, Validators.minLength(6)]],
            confirmPassword: [null, [Validators.required, Validators.minLength(6)]]
        }, {
            validator: PasswordValidation.MatchPassword
        });
    }
    ChangePasswordFormComponent.prototype.ngOnInit = function () { };
    Object.defineProperty(ChangePasswordFormComponent.prototype, "password", {
        get: function () {
            return this.form.get('password');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChangePasswordFormComponent.prototype, "confirmPassword", {
        get: function () {
            return this.form.get('confirmPassword');
        },
        enumerable: true,
        configurable: true
    });
    ChangePasswordFormComponent.prototype.onChangePassword = function () {
        this.loading = true;
        this.changePassword.emit(this.password.value);
    };
    return ChangePasswordFormComponent;
}());
export { ChangePasswordFormComponent };
